var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "document-apercu", style: { width: this.width + "px" } },
    [
      _c("b-loading", {
        attrs: { active: _vm.loading, "is-full-page": false }
      }),
      _c(
        "div",
        { staticClass: "resize", on: { mousedown: _vm.resizeMouseDown } },
        [_c("span")]
      ),
      _c(
        "div",
        {
          staticClass: "top",
          style: { visibility: _vm.pageCount ? "visible" : "hidden" }
        },
        [
          _vm.pageCount && _vm.pageCount > 1
            ? [
                _c(
                  "button",
                  {
                    staticClass: "button is-text",
                    class: { "is-disabled": _vm.page === 1 },
                    on: { click: _vm.prevPage }
                  },
                  [_c("b-icon", { attrs: { icon: "angle-left" } })],
                  1
                ),
                _c("div", { staticClass: "page-count" }, [
                  _vm._v(_vm._s(_vm.page) + " / " + _vm._s(_vm.pageCount))
                ]),
                _c(
                  "button",
                  {
                    staticClass: "button is-text",
                    class: { "is-disabled": _vm.page === _vm.pageCount },
                    on: { click: _vm.nextPage }
                  },
                  [_c("b-icon", { attrs: { icon: "angle-right" } })],
                  1
                )
              ]
            : _vm._e(),
          _c(
            "button",
            {
              staticClass: "button is-text rotate",
              on: { click: _vm.rotateClick }
            },
            [_c("b-icon", { attrs: { icon: "undo" } })],
            1
          ),
          _c(
            "button",
            {
              staticClass: "button is-text rotateleft",
              on: { click: _vm.rotateClickleft }
            },
            [_c("b-icon", { attrs: { icon: "undo" } })],
            1
          ),
          _c(
            "button",
            {
              staticClass: "button is-text zoomIn",
              on: { click: _vm.zoomInClick }
            },
            [_c("b-icon", { attrs: { icon: "plus" } })],
            1
          ),
          _c(
            "button",
            {
              staticClass: "button is-text zoomOut",
              on: { click: _vm.zoomOutClick }
            },
            [_c("b-icon", { attrs: { icon: "minus" } })],
            1
          ),
          _vm.allowDownload
            ? _c(
                "button",
                {
                  staticClass: "button is-text",
                  on: {
                    click: function($event) {
                      return _vm.download(_vm.details.name)
                    }
                  }
                },
                [
                  _c("b-icon", {
                    attrs: { icon: "download", size: "is-small" }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "button",
            { staticClass: "button is-text", on: { click: _vm.close } },
            [_c("b-icon", { attrs: { icon: "times" } })],
            1
          )
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "preview", style: { transform: _vm.rotateProperty } },
        [
          _c("canvas", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pageCount,
                expression: "pageCount"
              }
            ],
            ref: "canvas"
          }),
          !_vm.loading && !_vm.pageCount
            ? _c(
                "div",
                { staticClass: "pdf-only" },
                [
                  _c("b-icon", { attrs: { icon: "eye-slash", pack: "far" } }),
                  _c("div", [_vm._v("Aperçu non disponible")])
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _c(
        "div",
        { staticClass: "bottom" },
        [
          _vm.details
            ? [
                _c("div", { staticClass: "name" }, [
                  _vm._v(_vm._s(_vm.details.name))
                ]),
                _c("div", { staticClass: "size" }, [
                  _vm._v(_vm._s(_vm.details.size))
                ])
              ]
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }